"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantOrderTimeframeRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.MerchantOrderTimeframeRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.merchant_order_timeframe.label',
    fallbackLabel: 'Merchant order timeframe',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'BETWEEN_ZERO_THREE', label: 'fields.enm.merchant_order_timeframe.options.BETWEEN_ZERO_THREE', fallbackLabel: 'Between 0-3 days' },
        { key: 'BETWEEN_THREE_SEVEN', label: 'fields.enm.merchant_order_timeframe.options.BETWEEN_THREE_SEVEN', fallbackLabel: 'Between 3-7 days' },
        { key: 'ABOVE_SEVEN', label: 'fields.enm.merchant_order_timeframe.options.ABOVE_SEVEN', fallbackLabel: 'Above 7 days' },
    ],
    trackFieldValueWithAnalytics: false,
};
